<template>
  <div class="text-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <p>
          {{ options.statement }}
        </p>
        <canvas id="signaturePad" class="signaturePad" width=400 height=100></canvas>
        <br/>
        <button class="btn btn-secondary" @click.prevent="clearSignature()">
          <i class="fa fa-eraser fa-fw"></i> Clear
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import SignaturePad from 'signature_pad'
  import {
    validationClass,
    formControlValidationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'SignatureInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            value: ''
          }
        }
      }
    },
    computed: {
      validationClass,
      formControlValidationClass,
      validationMessage
    },
    data () {
      return {
        isDirty: false,
        isValid: false,
        signaturePad: ''
      }
    },
    mounted () {
      let canvas = document.getElementById('signaturePad')
      this.signaturePad = new SignaturePad(canvas, {
        penColor: 'rgb(0, 75, 142)',
        backgroundColor: 'rgb(255, 255, 255)',
        onEnd: () => {
          this.validate()
        }
      })
      if (this.value) {
        this.signaturePad.fromData(this.value)
      }
    },
    methods: {
      clearSignature () {
        this.signaturePad.clear()
        this.validate()
      },
      validate (val = this.value) {
        let data = this.signaturePad.toData()
        this.$emit('input', data)
        this.isDirty = true
        if (this.options.required && this.signaturePad.isEmpty()) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/SignatureInput.vue